import { render } from "./ActivateAccount.vue?vue&type=template&id=7f4891ba&scoped=true&ts=true"
import script from "./ActivateAccount.vue?vue&type=script&lang=ts"
export * from "./ActivateAccount.vue?vue&type=script&lang=ts"

import "./ActivateAccount.vue?vue&type=style&index=0&id=7f4891ba&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4891ba"]])

export default __exports__